import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

/**
 * Soft-delete a record and show a sonner toast with a 5-second Undo action.
 *
 *   await deleteWithUndo({
 *     deletePath: `/customers/${id}`,
 *     restorePath: `/customers/${id}/restore`,
 *     label: c.name,               // "Ram Singh"
 *     entityLabel: "customer",     // shown in toasts
 *     onChange: () => load(q),     // called after delete AND after undo/restore
 *   });
 *
 * Assumes both endpoints exist and respond 200 with {ok: true}.
 */
export async function deleteWithUndo({
  deletePath,
  restorePath,
  label = "",
  entityLabel = "item",
  onChange,
}) {
  try {
    await api.delete(deletePath);
  } catch (e) {
    toast.error(formatApiError(e.response?.data?.detail) || `Failed to delete ${entityLabel}`);
    return;
  }

  if (onChange) onChange();

  const message = label
    ? `Deleted ${entityLabel}: ${label}`
    : `${entityLabel[0].toUpperCase()}${entityLabel.slice(1)} deleted`;

  toast(message, {
    duration: 5000,
    action: {
      label: "Undo",
      onClick: async () => {
        try {
          await api.post(restorePath);
          toast.success(label ? `Restored ${label}` : `${entityLabel} restored`);
          if (onChange) onChange();
        } catch (e) {
          toast.error(formatApiError(e.response?.data?.detail) || "Failed to restore");
        }
      },
    },
  });
}
